var __rspack_ns_object = JSON.parse('{"fees":{"processingFee":{"amount":2.5,"currency":"EUR"}},"availablePayoutAmount":{"amount":100000,"currency":"EUR"}}')